import addEtag from "./addEtag";
import removeAuthHeader from "../removeAuthHeader";
export default function (res) {
    removeAuthHeader(res.config);
    return addEtag(res);
}
